import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import PreSelectedPrizeCard, {PrizeAssetHeader} from "../../PreSelectedPrizeCard/PreSelectedPrizeCard";
import PayoutDistributionTable from "../../PayoutDistributionTable/PayoutDistributionTable";
import {useGetRollingPrizeQuery} from "../../../stores/pickX/pickX.api";
import {PayoutModel} from "../../../constants/PickXEnums";
import _,{debounce} from "lodash";

import './PreSelectedParlayBanner.style.scss';
import {selectPartnerById, selectPrizeAssetById} from "../../../stores/pickX/pickX.selectors";
import {useSelector} from "react-redux";
const PreSelectedParlayBanner = ({preSelectedParlay}) => {

    const {data:rollingPrize} = useGetRollingPrizeQuery({
        currency: preSelectedParlay.FeeCurrency,
        wager: preSelectedParlay.Fee,
        sportId:preSelectedParlay.SportIds[0],
        payoutModel: preSelectedParlay.PayoutModel
    });

    const isPrizeAsset = preSelectedParlay.PayoutModel === PayoutModel.Assets;
    const prizeAsset = useSelector(state => selectPrizeAssetById(state, preSelectedParlay.PrizeAssetId));

    let payoutInfos = preSelectedParlay.getPayouts({rollingPrize, prizeAsset})

    const prizeCardRef = useRef(null);
    const payoutTableRef = useRef(null);

    const [preSelectedParlayBannerHeight, setPreSelectedParlayBannerHeight] = useState(0);
    const headerHeightRef = useRef(0);
    const mainContentMarginTopRef = useRef(0);

    const updateDimensions = debounce(() => {
        const element = document.querySelector('.LobbyView ');
        if (element) {
            const computedStyle = window.getComputedStyle(element);
            mainContentMarginTopRef.current = parseInt(computedStyle.marginTop, 10);
        }

        const headerElement = document.querySelector('.NavigationHeader');
        if (headerElement) {
            headerHeightRef.current = headerElement.offsetHeight;
        }

        const height = window.innerHeight - (headerHeightRef.current + mainContentMarginTopRef.current) - (mainContentMarginTopRef.current / 2);
        setPreSelectedParlayBannerHeight(height);
    }, 300);

    useLayoutEffect(() => {
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return () => {
            window.removeEventListener('resize', updateDimensions);
        };
    }, []);


    useLayoutEffect(() => {

        const updateHeight = () => {
            if (payoutTableRef.current && prizeCardRef.current) {
                prizeCardRef.current.style.height = `${payoutTableRef.current.offsetHeight}px`;
            }
        };

        updateHeight();

        const observer = new MutationObserver(updateHeight);
        if (payoutTableRef.current) {
            observer.observe(payoutTableRef.current, { childList: true, subtree: true, attributes: true });
        }

        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, [payoutInfos]);




    return (
        <div className="PreSelectedParlayBanner" style={{height: Math.max(preSelectedParlayBannerHeight,700),
                                                         }}>

            {isPrizeAsset && <PrizeAssetHeader parlay={preSelectedParlay} />}

            <div className="parlayContent">
                <PreSelectedPrizeCard ref={prizeCardRef}
                                      parlay={preSelectedParlay} showDecimal/>
                <PayoutDistributionTable extraTitle={'CONTEST'}
                                         ref={payoutTableRef}
                                         payoutInfos={payoutInfos}
                                         currency={preSelectedParlay.FeeCurrency}
                                         preSelectedParlayBannerHeight={preSelectedParlayBannerHeight}
                                />
            </div>
        </div>
    );
};

export default PreSelectedParlayBanner;